import {
  closestCorners,
  DndContext,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import ActionButton from "components/common/ActionButton";

import {
  Button,
  Form,
  Row,
  Table
} from "react-bootstrap";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useFetchPromotions } from "../../../../hooks/useFetchPromotions";

const SortableItem = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr ref={setNodeRef} style={style}>
      <td
        {...listeners}
        {...attributes}
        style={{
          cursor: "grab",
          textAlign: "center",
          width: "10px",
          // paddingTop: "15px",
        }}
      >
        ☰
      </td>
      {children}
    </tr>
  );
};

const Promotions = () => {
  const {
    register,
    getValues,
    watch,
    control,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { state } = useLocation();
  const navigate = useNavigate();

  const {
    fields: productPromotions,
    append: appendProductPromotions,
    remove: removeProductPromotions,
    move,
  } = useFieldArray({
    control,
    name: "productPromotions",
  });

  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 250,
        tolerance: 5,
      },
    })
  );

  // const handleDragEnd = (event) => {
  //   const { active, over } = event;
  //   if (active.id !== over.id) {
  //     const oldIndex = productPromotions.findIndex(
  //       (item) => item.id === active.id
  //     );
  //     const newIndex = productPromotions.findIndex((item) => item.id === over.id);
  //     move(oldIndex, newIndex);
  //   }
  // };


  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over) return;
    if (active.id !== over.id) {
      const oldIndex = productPromotions.findIndex(
        (item) => item.id === active.id
      );
      const newIndex = productPromotions.findIndex(
        (item) => item.id === over.id
      );

      // Move item in the field array
      move(oldIndex, newIndex);

      // Update sortOrder after moving
      const updated = getValues("productPromotions").map((item, index) => ({
        ...item,
        sortOrder: index + 1, // you can start from 0 if you want
      }));

      setValue("productPromotions", updated, { shouldDirty: true });
    }
  };



  const { data, isLoading } = useFetchPromotions();
  const productPromotionsValues = watch("productPromotions") || [];

  // if (isLoading) {
  //   return <Spinner variant="primary" animation="border" />;
  // }

  return (
    <>
      {/* <Card.Header as="h6" className="bg-body-tertiary mb-2">
        Shipping And Warranty
      </Card.Header> */}

      {isLoading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Row className="gx-2 ">
          <DndContext
            sensors={sensors}
            collisionDetection={closestCorners}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={productPromotions.map((item) => item.id)}
              strategy={verticalListSortingStrategy}
            >
              <Table responsive>
                <thead className="bg-200">
                  <tr>
                    <th scope="col" className="w-0 fs-10 text-center" style={{ width: "10px" }}>
                      Order
                    </th>

                    <th scope="col" className="fs-10">
                      Name
                    </th>

                    <th
                      style={{ width: "10px" }}
                      scope="col"
                      className="fs-10 text-center"
                    >
                      Status
                    </th>

                    <th
                      scope="col"
                      style={{ padding: "9px", width: "10px" }}
                      className=" text-end"
                    >
                      <ActionButton
                        icon="plus"
                        variant="success"
                        title="Add"
                        className="px-1 py-0"
                        onClick={() => appendProductPromotions({})}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {productPromotions.map((item, index) => (
                    <SortableItem key={item.id} id={item.id}>
                      <td style={{ padding: "5px" }}>
                        <Form.Group controlId="formGroupName">
                          <Form.Select
                            aria-label="promotionId"
                            isInvalid={
                              !!errors.productPromotions?.[index]
                                ?.promotionId
                            }
                            {...register(
                              `productPromotions[${index}].promotionId`
                            )}
                          >
                            <option value="">Select</option>
                            {/* {data?.data?.data?.map((d) => (
                              <option value={d.id}>{d.name}</option>
                            ))} */}


                            {data?.data?.data
                              ?.filter((d) => {
                                const selectedIds = productPromotionsValues
                                  .map((p) => p.promotionId)
                                  .filter(Boolean); // remove undefined or empty
                                const currentValue = productPromotionsValues[index]?.promotionId;

                                // Keep current value, exclude others
                                return !selectedIds.includes(d.id.toString()) || d.id.toString() === currentValue;
                              })
                              .map((d) => (
                                <option value={d.id} key={d.id}>
                                  {d.name}
                                </option>
                              ))}

                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.productPromotions?.[index]?.promotionId
                                ?.message
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </td>
                      <td style={{ padding: "5px" }} className="text-center">
                        <Form.Check
                          type="checkbox"
                          id="defaultSwitch"
                          className="mt-1"
                          defaultChecked={!state}
                          isInvalid={!!errors.productPromotions?.[index]?.status}
                          {...register(`productPromotions[${index}].status`)}
                        />
                      </td>
                      <td
                        style={{ padding: "5px", maxWidth: "10px" }}
                        className="text-center"
                      >
                        <ActionButton
                          icon="trash-alt"
                          title="Delete"
                          variant="danger"
                          className="px-1 py-0"
                          onClick={() => removeProductPromotions(index)}
                        />
                      </td>
                    </SortableItem>
                  ))}
                </tbody>
              </Table>
            </SortableContext>
          </DndContext>
        </Row>
      )}
    </>
  );
};

export default Promotions;
